import React, { useState } from 'react';
import { processCart } from 'services';
import { showError, showSuccess } from 'utils';
import DeliveryMethods from './DeliveryMethods';
import styles from './index.module.scss';

const ProcessCartModal = props => {
  const [loading, setLoading] = useState<boolean>(false);
  const [deliveryMethod, setDeliveryMethod] = useState({}) as any;
  const [notes, setNotes] = useState('');
  const {
    cart,
    toggleModal,
    onSuccess,
    userId,
  } = props;
  const {
    nextRoutedDeliveryAvailableDays,
    isOnDemandDeliveryPossible,
  } = cart;
  const handleSecondaryButtonClick = async () => {
    toggleModal();
  };

  const processCartFn = async () => {
    setLoading(true);
    try {
      const res = await processCart({
        notes,
        preferredDeliveryDay: deliveryMethod?.preferredDeliveryDay,
        selectedAddressId: cart?.selectedAddress?.objectId,
        selectedDeliveryMethod: deliveryMethod?.deliveryMethod,
        selectedLocale: 'English',
        selectedPaymentId: cart?.paymentMethod?.id,
        userId,
      });
      if (onSuccess) {
        onSuccess(res);
      }
      toggleModal();
      showSuccess('Cart processed successfully.');
    } catch (e) {
      showError(e);
    } finally {
      setLoading(false);
    }
  };

  const getDeliveryMethodsBlock = () => {
    if(nextRoutedDeliveryAvailableDays?.length < 1 && !isOnDemandDeliveryPossible){
      return null;
    }
    return (
      <div className="mt-4 mb-4">
        <DeliveryMethods
          selectedCard={deliveryMethod}
          nextRoutedDeliveryAvailableDays={nextRoutedDeliveryAvailableDays}
          onSelect={(method: any) => {
            setDeliveryMethod({
              deliveryMethod: method.type,
              preferredDeliveryDay: method.preferredDeliveryDay,
            });
          }} 
          isOnDemandDeliveryPossible={isOnDemandDeliveryPossible}
        />
      </div>
    );
  };

  const getNotes = () => {
    return (
      <div className={styles['notes']}>
        <div className={styles['label']}>Notes</div>
        <input
          value={notes}
          onChange={e => setNotes(e.target.value)}
          disabled={loading}
        />
      </div>
    );
  };

  return (
    <div className={styles['main-container']}>
      <div className={styles['modal-container']}>
        <div className={styles['modal-header']}>
          <div>
            <div className={styles['modal-title']}>Are you sure you want to process the cart?</div>
          </div>
          <i className={'fa fa-times'} onClick={toggleModal} />
        </div>
        <div className={styles['modal-body']}>
          {getDeliveryMethodsBlock()}
          {getNotes()}
        </div>
        <div className={styles['modal-footer']}>
          <button
            disabled={loading}
            type={'button'}
            className={`${styles['cancel-button']}`}
            onClick={handleSecondaryButtonClick}
          >
            Cancel
          </button>
          <button
            disabled={loading}
            type={'button'}
            className={`${styles['submit-button']}`}
            onClick={processCartFn}
          >
            Process
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProcessCartModal;